import Avatar from "common/components/Avatar"

const RazonSocial = ({
  razonSocial,
  cif,
}: {
  razonSocial?: string | null
  cif?: string | null
}) => {
  return (
    <div className='tw-flex tw-flex-row tw-max-w-full tw-mb-6'>
      <div className='tw-mr-3'>
        <Avatar
          initials={razonSocial?.substring(0, 2)}
          size='tw-w-12 tw-h-12'
        />
      </div>
      <div className='tw-w-[calc(100%-60px)] tw-flex tw-flex-col tw-h-12 tw-justify-between'>
        <div className='tw-w-full tw-truncate tw-overflow-hidden tw-whitespace-nowrap tw-text-lg tw-font.medium tw-text-start'>
          {razonSocial ?? ""}
        </div>
        <div className='tw-text-sm tw-font-normal tw-text-start'>
          {cif ?? ""}
        </div>
      </div>
    </div>
  )
}

export default RazonSocial
